/**
 * Consistent Lucide icon wrapper — stroke width, sizing, and colour.
 */
const SIZES = {
  xs: 16,
  sm: 18,
  md: 20,
  nav: 22,
  lg: 24,
  xl: 28,
};

export default function KipaIcon({
  icon: Icon,
  size = "md",
  className = "",
  color = "currentColor",
  strokeWidth = 1.75,
}) {
  if (!Icon) return null;
  const px = typeof size === "number" ? size : SIZES[size] || 20;
  return (
    <Icon
      size={px}
      strokeWidth={strokeWidth}
      color={color}
      className={`flex-shrink-0 ${className}`.trim()}
      aria-hidden
    />
  );
}

export { SIZES as ICON_SIZES };
